import { createFileRoute } from '@tanstack/react-router';
import { BranchesPage } from '@/features/portal/branches';
import { Forbidden } from '@/features/portal/ui';
import { useIsAdmin } from '@/features/auth/use-auth';

function BranchesRoute() {
  const isAdmin = useIsAdmin();
  return isAdmin ? <BranchesPage /> : <Forbidden />;
}

export const Route = createFileRoute('/_app/branches')({
  component: BranchesRoute,
});
